module.exports = __webpack_public_path__ + "img/Mask Group 131.e5a6f41b.svg";